// extracted by mini-css-extract-plugin
module.exports = {"web-checkout__container":"WebCheckoutTemplate_web-checkout__container__iwvq2","text":"WebCheckoutTemplate_text__uKQeB"};